import { useState } from "react";
import styles from "./tenantofferunsure.module.css";
import Loader from "../../../components/Loader";
import { Helmet } from "react-helmet";
import { Background, Parallax } from 'react-parallax';
import { Link as Linkto, useHistory } from "react-router-dom";
import moment from 'moment';

const TenantOfferUnsure = () => {
    const [loading, setLoading] = useState(false);

    return (<>
        {loading && <Loader />}
        <Helmet title="Offer" />
        <Parallax strength={300} className="RentalParallax">
            <Background className="custom-bg">
            <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
            </Background>
        </Parallax>
    
        <div className="WhiteBG">
            <div className={`${styles.RentalAppliArea}`}>
                <div className={`${styles.RentalAppliSuccessSec}`}>
                    <div className={`${styles.SuccessImgSec}`}>
                        <iframe className={`${styles.First}`} src="https://lottie.host/embed/241d4b6f-684b-476f-81db-c79f4bb52cdc/i2K4mnqXqc.lottie"></iframe>
                    </div>
                    <p className={`${styles.PaymentSuccessTitle}`}>Thank You!</p>
                    <p className={`${styles.PaymentSuccessTitleSub}`}>Thank you for your response. The management team will be in touch with you soon.</p>
                </div>
            </div>
    
            <div className={`${styles.FooterWrap}`}>
                <div className={`${styles.footerMain}`}>

                    <div className={`${styles.footerMainLeft}`}>
                        <Linkto to={'/'}><img src='/static/img/logo.svg' alt="logo" /></Linkto>
                    </div>

                    <div className={`${styles.footerMainRight}`}>
                        <div>
                            <h3>CONTACT US</h3>
                            <ul>
                                <li><a href={`mailto: dev@fbc.nyc`}>dev@fbc.nyc</a></li>
                                <li><a href={`tel: (313) 777-8088`} >(313) 777-8088</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3>FIND US</h3>
                            <ul>
                                <li>2211 Pingree St <br />Detroit, MI 48206</li>
                            </ul>
                        </div>
                        <div>
                            <h3>LEGAL</h3>
                            <ul>
                                <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li>PropertyDek © {moment().format("YYYY")}.<br />All rights reserved.</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </>)
}

export default TenantOfferUnsure;